import store from '@/store';

export function appIsActive() {
  return (
    store.getters['internationalization/getCountrySettings'].status === 'full'
  );
}
